import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FormikProps } from "formik";

import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2
import {
  BaseDefinitionType,
  ListOfBaseDefinitionType,
} from "src/interface/enum/BaseDefinitionType ";
import { ListOfTagsColor } from "src/interface/enum/TagsColor";

// ساخت schema برای اعتبارسنجی با yup

const BaseDefinitionForm = ({ formik }: { formik: FormikProps<any> }) => {
  return (
    <Grid2 container spacing={1} marginBottom={1} padding={0.8}>
      <Grid2 size={5}>
        <FormControl
          fullWidth
          error={formik.touched.definType && Boolean(formik.errors.definType)}
        >
          <InputLabel id="demo-simple-select-helper-label">نوع آیتم</InputLabel>
          <Select
            {...formik.getFieldProps("definType")}
            fullWidth
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="نوع آیتم"
          >
            {ListOfBaseDefinitionType.map((row: any) => (
              <MenuItem value={row.value}>{row.label}</MenuItem>
            ))}
          </Select>
          <FormHelperText>
            {(formik.touched.definType && formik.errors.definType) as boolean}
          </FormHelperText>
        </FormControl>
      </Grid2>
      <Grid2 size={formik.values.definType === BaseDefinitionType.Tags ? 5 : 7}>
        <TextField
          {...formik.getFieldProps("caption")} // استفاده از ویژگی‌های فرمیک
          label="عنوان"
          error={formik.touched.caption && Boolean(formik.errors.caption)}
          helperText={
            (formik.touched.caption && formik.errors.caption) as boolean
          }
          variant="outlined"
          fullWidth
        />
      </Grid2>
      {formik.values.definType === BaseDefinitionType.Tags && (
        <Grid2 size={2}>
          <FormControl
            fullWidth
            error={formik.touched.other && Boolean(formik.errors.other)}
          >
            <InputLabel id="demo-simple-select-helper-label">رنگ</InputLabel>
            <Select
              {...formik.getFieldProps("other")}
              fullWidth
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              label="رنگ"
            >
              {ListOfTagsColor.map((row: any) => (
                <MenuItem value={row.value}>{row.label}</MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {(formik.touched.other && formik.errors.other) as boolean}
            </FormHelperText>
          </FormControl>
        </Grid2>
      )}
      {/* فیلد نام فرم */}
    </Grid2>
  );
};

export default BaseDefinitionForm;
